import React, { Component } from 'react'
// import menu from '../assets/menu.png'
import closeform from '../assets/closeform.png'
// import SideButton from '../components/SideButton'

export default class FormMenuItem extends Component {
    itemClick(){
        this.props.clickHandle();
    }

    render() {
        return (
            <div className="formMenuItem" onClick={this.itemClick.bind(this)}>
                {this.props.image!==null && <img src={this.props.image} className="accordionToggleImage" alt=""/>}
                {this.props.image===null && <img style={{height:'30px'}} src={closeform} alt=""/>}
                {/* {this.props.image===null && <SideButton small noFlex showTitle={false} imgWidth="auto" imgHeight="25px" borderWidth="0px" borderRadius="0px" icon1={menu} icon2={menu} selected={false} handler={this.itemClick.bind(this)}/>} */}
                <div className="formMenuItemTitle">{this.props.title}</div>
            </div>
        )
    }
}
